<template>
	<div style="display: contents">
		<template>
			<CostItemSingleStage
				:costItem="costItems"
				:ufValue="ufValue"
				:colWidths="colWidths"
				:itemLevel="0"
				inputLabel="Etapa"
				:showSubitems="false"
				:isEditable="false" 
				:currency="currency"
				@change="updateStage($event)"/>
		</template>

		<template v-for="(categoryGroup, categoryIndex) in groupedCostItems">
			<tr class="category-header" v-if="categoryGroup.category" :key="'categoryA-' + categoryIndex">
				<td style="vertical-align: middle" :width="colWidths[0]" class="text-left">
					<div class="d-flex align-center justify-space-between" :style="'padding-left: ' + paddingLevelForFirstElement">
						<div>
							<p class="mb-0" style="font-size: 8px;">Costo Base</p>
							<p class="mb-0 caption font-weight-bold">{{ categoryGroup.category.name }}</p>
						</div>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									icon
									x-small
									color="black"
									@click="toggleCategoryVisibility(categoryGroup.category.id)"
									v-bind="attrs"
									v-on="on"
								>
									<v-icon size="22" :style="'transform: rotate(' + (showCategories.includes(categoryGroup.category.id) ? '180deg' : '0deg') + '); transition: transform 0.3s;'">mdi-chevron-down</v-icon>
								</v-btn>
							</template>
							<span>Ver Detalle</span>
						</v-tooltip>
					</div>
				</td>
				<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[1]" class="text-right">
					<div class="d-flex align-center justify-end">
					</div>
				</td>
				<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[2]" class="text-right">
					<div class="d-flex align-center justify-end">
					</div>
				</td>
				<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[3]" class="text-right">
					<div class="d-flex align-center justify-end">
					</div>
				</td>
				<td style="vertical-align: middle;" :width="colWidths[4]" class="text-right">
					<div class="d-flex align-center justify-end">
						{{ getCategoryGroupValues(categoryGroup).total_cost_uf | toThousandFilter(2) }}
					</div>
				</td>
				<td style="vertical-align: middle;" :width="colWidths[5]" class="text-right">
					<div class="d-flex align-center justify-end">
						${{ getCategoryGroupValues(categoryGroup).total_cost_clp | toThousandFilter }}
					</div>
				</td>
				<td style="vertical-align: middle;" :width="colWidths[6]" class="text-center">
					<div class="d-flex align-center justify-center">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									icon
									dark
									x-small
									color="error"
									@click="deleteCategory(categoryGroup)"
									v-bind="attrs"
									v-on="on"
								>
									<v-icon small dark>mdi-delete-outline</v-icon>
								</v-btn>
							</template>
							<span>Eliminar Item</span>
						</v-tooltip>
					</div>
				</td>
			</tr>

			<!-- Items within category (shown/hidden based on category state) -->
			<div style="display: contents" v-show="(!categoryGroup.category || showCategories.includes(categoryGroup.category.id))" :key="'itemcatContainer-' + categoryIndex">
				<template v-for="(item, indexA) in categoryGroup.items">
					<CostItemSingle
						:key="'item'+(item.id || indexA)"
						:costItem="item"
						:costCategoriesConfig="costCategoriesConfig"
						:ufValue="ufValue"
						:itemLevel="categoryGroup.category ? itemLevel + 1:itemLevel"
						:colWidths="colWidths"
						:isEditable="!item.subitems || item.subitems?.length == 0"
						:currency="currency"
						@change="updateItem(item.originalIndex, $event)"
						@change:setCategory="setCategoryToItem(item.originalIndex, $event)"
						@onToggleShowDetails="toggleToShowDetails"/>

					<CostItemSingle
						:costItem="subitem"
						:ufValue="ufValue"
						:colWidths="colWidths"
						:itemLevel="categoryGroup.category ? itemLevel + 2:itemLevel + 1"
						:showSubitems="false"
						:currency="currency"
						v-show="showDetails.includes(item.id)"
						v-for="(subitem, index) in item.subitems"
						:key="'subitem'+(subitem.id || index)"
						@change="updateSubItem(item.originalIndex, index, $event)"/>

					<tr class="no-hover-cells" :key="'add_subitem'+(item.id || indexA)" v-if="showDetails.includes(item.id)">
						<td :width="colWidths[0]" style="border-right: 0;" >
							<div :style="'padding-left: ' + paddingLevelForInnerElement">
								<v-btn
									outlined
									depressed
									color="#808080"
									style="height: auto;"
									class="my-2"
									small
									@click="addSubItem(item.originalIndex)"
								>
									<v-icon small>mdi-plus</v-icon>
									<div class="text-left ml-1">
										<p class="text-left mb-0" style="font-size: 10px;">Agregar Sub Item y Costos a:</p>
										<p class="text-left mb-0 caption font-weight-bold">{{ item.name }}</p>
									</div>
								</v-btn>
							</div>
						</td>
					</tr>
				</template>
			</div>
		</template>

		<tr class="no-hover-cells">
			<td :width="colWidths[0]" style="border-right: 0;" >
				<div :style="'padding-left: ' + paddingLevelForFirstElement">
					<v-btn
						outlined
						depressed
						color="#808080"
						style="height: auto;"
						class="my-2"
						small
						@click="addItem"
					>
						<v-icon small>mdi-plus</v-icon>
						<div class="text-left ml-1">
							<p class="text-left mb-0" style="font-size: 10px;">Agregar Item y Costos a:</p>
							<p class="text-left mb-0 caption font-weight-bold">{{ costItems.stage?.name }}</p>
						</div>
					</v-btn>
				</div>
			</td>
		</tr>
	</div>
</template>

<script>
import CostItemSingle from '@/components/Views/Projects/Parts/CostItemSingle'
import CostItemSingleStage from '@/components/Views/Projects/Parts/CostItemSingleStage'

export default {
	name: 'CostItemContainerStages',
	components: {CostItemSingle, CostItemSingleStage},
	props: {
		costCategoriesConfig: {
			type: Array,
			required: true
		},
		costItems: {
			type: Object,
			required: true
		},
		isM2Selection: {
			type: Boolean,
			default: false
		},
		ufValue: {
			type: Number,
			required: true
		},
		itemLevel: {
			type: Number,
			default: 0
		},
		colWidths: {
			type: Array,
			required: true
		},
		currency: {
			type: String,
			required: true
		}
	},
	computed: {
		paddingLevelForFirstElement(){
			const basePadding = 8
			const padding = basePadding * this.itemLevel
			return padding + '%'
		},
		paddingLevelForInnerElement(){
			const basePadding = 8
			const padding = basePadding * ( this.itemLevel + 1 )
			return padding + '%'
		},
		groupedCostItems() {
			const groups = {};
			
			if (!this.costItems.items || !Array.isArray(this.costItems.items)) {
				return [];
			}

			this.costItems.items.forEach((item, index) => {
				const categoryId = item.company_cost_category?.id || 'no-category';
				
				if (!groups[categoryId]) {
					groups[categoryId] = {
						category: item.company_cost_category || null,
						items: []
					};
				}
				groups[categoryId].items.push({
					...item,
					originalIndex: index
				});
			});
			
			return Object.values(groups);
		}
	},
	watch: {
	},
	data(){
		return {
			showDetails: [],
			showCategories: [],
			requiredRule: [
				v => !!v || 'Campo requerido'
			],
		}
	},
	mounted(){
	},
	methods: {
		deleteCategory(categoryGroup){
			const updatedCostItems = [...this.costItems.items];
			const toDeleteIdsArray = categoryGroup.items.map(item => item.id)
			const newItems = updatedCostItems.filter((item) => {
				return !toDeleteIdsArray.includes(item.id)
			})
			this.$emit('update:costItems', newItems);
		},
		getCategoryGroupValues(categoryGroup){
			const totals = {
				qty: 0,
				unit_cost_uf: 0,
				unit_cost_clp: 0,
				total_cost_uf: 0,
				total_cost_clp: 0
			};

			const parse = (n) => parseFloat(n) || 0;

			if (Array.isArray(categoryGroup.items)) {
				for (const item of categoryGroup.items) {
					if (Array.isArray(item.subitems) && item.subitems.length) {
						for (const sub of item.subitems) {
							const qty = parse(sub.qty);
							const uf = parse(sub.unit_cost_uf);
							const clp = parse(sub.unit_cost_clp);

							totals.qty += qty;
							totals.unit_cost_uf += uf;
							totals.unit_cost_clp += clp;
							totals.total_cost_uf += uf * qty;
							totals.total_cost_clp += clp * qty;
						}
					} else {
						const qty = parse(item.qty);
						const uf = parse(item.unit_cost_uf);
						const clp = parse(item.unit_cost_clp);

						totals.qty += qty;
						totals.unit_cost_uf += uf;
						totals.unit_cost_clp += clp;
						totals.total_cost_uf += uf * qty;
						totals.total_cost_clp += clp * qty;
					}
				}
			}

			return totals;
		},
		toggleCategoryVisibility(categoryId) {
			const index = this.showCategories.indexOf(categoryId);
			
			if (index === -1) {
				this.showCategories.push(categoryId);
			} else {
				this.showCategories.splice(index, 1);
			}
		},
		setCategoryToItem(indexItem, updatedItem) {
			const updatedCostItems = [...this.costItems.items];
			const newItems = (updatedItem.items || []).map(item => {
				const { id, ...rest } = item;
				return {
					company_item_id: id,
					...rest,
					company_cost_category: {
						id: updatedItem.id,
						name: updatedItem.name
					}
				};
			});
			const before = updatedCostItems.slice(0, indexItem);
			const after = updatedCostItems.slice(indexItem + newItems.length);
			const updatedItems = [...before, ...newItems, ...after];

			const updatedStage = {
				...this.costItems,
				items: updatedItems
			};

			this.$emit('update:costItems', updatedStage);
		},
		addItem() {
			const newItem = {
				id: null,
				name: null,
				qty: 0,
				unit_cost_uf: 0,
				unit_cost_clp: 0
			};

			const currentItems = Array.isArray(this.costItems.items)
				? [...this.costItems.items]
				: [];

			currentItems.push(newItem);

			const newCostItems = {
				...this.costItems,
				items: currentItems
			};

			this.$emit('update:costItems', newCostItems);
		},
		addSubItem(indexItem) {
			const newSubitem = {
				id: null,
				name: null,
				qty: 0,
				unit_cost_uf: 0,
				unit_cost_clp: 0
			};

			const costItem = { ...this.costItems.items[indexItem] };

			const updatedSubitems = Array.isArray(costItem.subitems)
				? [...costItem.subitems]
				: [];

			updatedSubitems.push(newSubitem);
			costItem.subitems = updatedSubitems;

			const updatedItems = [...this.costItems.items];
			updatedItems.splice(indexItem, 1, costItem);

			const updatedCostItems = {
				...this.costItems,
				items: updatedItems
			};

			this.$emit('update:costItems', updatedCostItems);
		},
		updateStage(updateStage) {
			this.$emit('update:costItems', updateStage);
		},
		updateSubItem(indexItem, indexSubItem, updatedSubitem) {
			const costItem = { ...this.costItems.items[indexItem] };
			const updatedSubitems = [...(costItem.subitems || [])];

			if (updatedSubitem) {
				updatedSubitems.splice(indexSubItem, 1, updatedSubitem)
			} else {
				updatedSubitems.splice(indexSubItem, 1)
			}
			
			costItem.subitems = updatedSubitems;

			const updatedItems = [...this.costItems.items];
			updatedItems.splice(indexItem, 1, costItem);

			const updatedCostItems = {
				...this.costItems,
				items: updatedItems
			};
			this.$emit('update:costItems', updatedCostItems);
		},
		updateItem(indexItem, updatedItem) {
			const updatedItems = [...this.costItems.items];
			if(updatedItem){
				updatedItems.splice(indexItem, 1, updatedItem);
			}
			else{
				updatedItems.splice(indexItem, 1);
			}

			const updatedCostItems = {
				...this.costItems,
				items: updatedItems
			};
			this.$emit('update:costItems', updatedCostItems);
		},
		updateChild(newVal, item){
			console.log('updateChild newVal: ', newVal)
			console.log('updateChild item: ', item)
		},
		toggleToShowDetails(item_id) {
			if (!this.showDetails) {
				this.showDetails = []
			}

			const index = this.showDetails.indexOf(item_id)

			if (index === -1) {
				this.showDetails.push(item_id)
			} else {
				this.showDetails.splice(index, 1)
			}
		},
	}
}
</script>

<style scoped>
	tr.no-hover-cells,
	tr.no-hover-cells td {
		background-color: inherit !important;
	}
	.category-header{
		background-color: #ececec;
	}
	
	.category-header:hover .category-title-container {
		background-color: #eeeeee !important;
	}
</style>